module.exports = __webpack_public_path__ + "img/8.16687e38.jpg";